import { Button } from '../../Button'
import { tm } from '../../tm'
import type { ButtonProps } from '../../Button'
import type { Project, ProjectId } from '@captaincause/types'
import type { ReactNode } from 'react'

interface ShowProps {
  project: Project
  className?: string
  promoted: boolean
  Link?: (props: ButtonProps) => ReactNode
  onClick?: (id: ProjectId) => void
}

const noop = () => {}
export function Show({
  project,
  promoted,
  onClick = noop,
  Link = undefined,
  className = '',
}: ShowProps) {
  const Component = Link ?? Button

  return (
    <Component
      className={className}
      href={Link ? `/projects/${project.slug}` : ''}
      onClick={onClick ? () => onClick(project.id) : undefined}
      breakout
      variant="raw"
    >
      <div
        className={tm(
          'line-clamp-2 min-h-[2lh] w-full flex-1 text-left text-base font-semibold leading-6 -tracking-[0.32px] md:line-clamp-3 md:min-h-[3lh]',
          promoted && 'text-lg',
        )}
      >
        {project.name}
      </div>
    </Component>
  )
}
